<!-- 多列多行列表,两端对齐：模块头+图片+标题+链接 -->
<template>
<div class="content-block">
  <div class="info-list-title"  v-if="showTitle">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <a href="#"  v-if="showMore">更多</a>
  </div>
  <div class="info-list-content">
    <div class="list-container">
      <div class="list-container-cell" v-for="info in infoPage.list" :style="{'width': celWidth,'padding-top':colPadding/2+'px','padding-bottom':colPadding/2+'px'}">
        <component :is="infoBlock" :info="info"/></component>
      </div>
      <div class="no-record" v-if="infoPage.list.length < 1">暂无数据</div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ColInfoBetweenList',
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    showMore: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    col: {
      type: String,
      default: '3'
    },
    colPadding: {
      type: String,
      default: '30'
    },
    count: {
      type: String,
      default: '3'
    },
    infoBlock:{
      type:Object,
      default:function(){return {}}
    },
    infoPage:{
      type:Object,
      default:function(){return {list:[],total:0}}
    }

  },
  data() {
    return {
      celWidth: "calc(100%/" + this.col + " - "+this.colPadding+"px)",
    }
  },
  methods:{
    queryPage:function(params){
      //console.log("查询分页数据："+JSON.stringify(params));
      this.$emit("queryPage",params);
    }
  },
  created:function(){
    //this.infoList=this.Global.newsListDemo.slice(0,this.count);
    this.queryPage({page:1,pageSize:this.count,title:this.title});
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.list-container {
  display: flex;
  flex-wrap: wrap;
  justify-content:space-between;
}

.list-container-cell {
  position:relative;
  box-sizing: border-box;
  height: 100%;
  background: #fff;
  border: 0px solid red;
}

.no-record{
  position:relative;
  width:100%;
  height:40px;
  background:#eee;
  font-size:12px;
  text-align:center;
  line-height:40px;
  color:#888888;
}

</style>



// WEBPACK FOOTER //
// src/components/block/ColInfoBetweenList.vue